import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { CurrencyCatalogsDTO } from '@/domain/currencies'

const STORAGE_KEY = 'app-preferences-store'

const AVAILABLE_LANGUAGES_ARRAY = ['en', 'ar', 'pt', 'ru'] as const

export type AVAILABLE_LANGUAGES = (typeof AVAILABLE_LANGUAGES_ARRAY)[number]

function getDefaultLanguage(): AVAILABLE_LANGUAGES {
  // TEMPORARY SOLUTION: always return 'en' instead of detecting browser language
  return 'en'

  // OLD CODE (commented out for possible rollback when all translations are available):
  // // Get browser language
  // const browserLanguage = navigator.language.split('-')[0]
  // if (
  //   browserLanguage &&
  //   AVAILABLE_LANGUAGES_ARRAY.includes(browserLanguage as AVAILABLE_LANGUAGES)
  // ) {
  //   return browserLanguage as AVAILABLE_LANGUAGES
  // }
  // return 'en'
}

const DEFAULT_LANGUAGE = getDefaultLanguage()

const DEFAULT_CURRENCY: CurrencyCatalogsDTO = {
  id: 3,
  isin: 'USD',
  label: '$',
  precision: 2,
  factor: 100,
  img_url:
    'https://storage.googleapis.com/kem-catalog-stage/currencies/USD.png',
  name: 'U.S. Dollar',
}

export interface AppPreferencesState {
  language?: AVAILABLE_LANGUAGES
  displayCurrency?: CurrencyCatalogsDTO
  paymentCurrency?: CurrencyCatalogsDTO
  hasSeenPaymentCurrencyBS?: boolean
}

interface AppPreferencesActions {
  setAppPreferences: (preferences: Partial<AppPreferencesState>) => void
  setDisplayCurrency: (currency: CurrencyCatalogsDTO) => void
  setPaymentCurrency: (currency: CurrencyCatalogsDTO) => void
  setLanguage: (language: AVAILABLE_LANGUAGES) => void
  resetState: () => void
}

type AppPreferencesStore = AppPreferencesState & AppPreferencesActions

const initialState: AppPreferencesState = {
  language: DEFAULT_LANGUAGE,
  displayCurrency: DEFAULT_CURRENCY, // Default USD
  paymentCurrency: DEFAULT_CURRENCY,
  hasSeenPaymentCurrencyBS: false,
}

export const useAppPreferencesStore = create<AppPreferencesStore>()(
  persist(
    (set) => ({
      ...initialState,

      setAppPreferences: (preferences) =>
        set((state) => ({
          ...state,
          ...preferences,
        })),

      setDisplayCurrency: (currency) =>
        set((state) => ({
          ...state,
          displayCurrency: currency,
        })),

      setPaymentCurrency: (currency) =>
        set((state) => ({
          ...state,
          paymentCurrency: currency,
        })),

      setLanguage: (language) =>
        set((state) => ({
          ...state,
          language,
        })),

      resetState: () => {
        localStorage.removeItem(STORAGE_KEY)
        set({ ...initialState })
      },
    }),
    {
      name: STORAGE_KEY,
      storage: {
        getItem: (name) => {
          const str = localStorage.getItem(name)
          return str ? JSON.parse(str) : null
        },
        setItem: (name, value) => {
          localStorage.setItem(name, JSON.stringify(value))
        },
        removeItem: (name) => localStorage.removeItem(name),
      },
    },
  ),
)
